import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { AppConfigService } from "src/modules/shared/services/app-config.service";
import { IGetOperationResponse } from 'src/modules/shared/interfaces/IGetOperationResponse';
import { LoaderService } from "src/modules/shared/services/loader.service";
import { NavigationExtras, Router } from "@angular/router";
import { ApplicantManagementService } from "src/modules/profile-management/services/applicant-management-service.service";

const httpOptions = {
  headers: new HttpHeaders({
    "Content-Type": "application/json",
    Authorization: "my-auth-token"
  })
};

const httpUserOptions = {
  headers: new HttpHeaders({ "Content-Type": "application/json" }),
  withCredentials: true,
  observe: "response" as "response"
};

@Injectable({
  providedIn: "root"
})
export class LoginService {
  public baseUrl: string;

  constructor(
    private http: HttpClient,
    private router: Router,
    private appConfig: AppConfigService
  ) {
    this.baseUrl = this.appConfig.getAppConfig().AppUrl + "/api";
  }

  post(object: any, controllerName: string, action: string): Observable<any> {
    return this.http
      .post<object>(
        this.baseUrl + "/" + controllerName + "/" + action,
        object,
        { responseType: "json" }
      )
      .pipe
      // catchError(this.handleError('',))
      ();
  }

  GetApplicantInfoByCPRandCR(object: any): Observable<any> {
    return this.http
      .post<object>(
        this.baseUrl + "/UserDataManager/GetApplicantInfoByCPRandCR",
        object,
        httpUserOptions
      )
      .pipe
      // catchError(this.handleError('',))
      ();
  }

  get(controllerName: string, actionName: string): Observable<any> {
    return this.http
      .get<object>(this.baseUrl + "/" + controllerName + "/" + actionName)
      .pipe
      // catchError(this.handleError('',))
      ();
  }

  RedirectToLogin() {
    this.router.navigate(["login/email"]);
  }

  RegisterToLogin() {
    let registerURL = this.appConfig.getAppConfig().RegisterURL;
    document.location.href = registerURL;
  }

}
